exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 768px) {\n    h1.sideways {\n        margin-top: 50px;\n    }\n}\n@media (max-width: 1400px) and (min-width: 992px) {\n    .container.sideways-aligned {\n        padding-left: 125px; \n    }\n}\nh3 {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    /* text-align: right; */\n    background: #FFF;\n    color: #FC4B0A;\n    font-family: 'Special Elite', cursive;\n    \n    z-index: 9;\n    padding-left:5px;\n    padding-right: 5px;\n    text-align: center;\n    min-width: 75%;\n}\n.aspect-ratio-box:hover {\n    -webkit-filter: grayscale(100%);\n            filter: grayscale(100%);\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /tmp/build_fdb7fa8d/src/app/videos/videos.component.css
// module id = ../../../../../src/app/videos/videos.component.css
// module chunks = main